import { httpService } from '@/services/HttpService';
import { publicIPAddressService } from '@/components/network/public-ip-address/services/PublicIPAddressService';
import { privateNetworkService } from '@/components/network/private-network/services/PrivateNetworkService';

class WorkspaceAccessService {
  workspaces: any = [];
  publicIpAddresses: any = [];
  privateNetworks: any = [];

  getWorkspaces(): Promise<any> {
    return httpService.get('workspaces');
  }

  getPublicIpAddresses(workspaceId: any, regionId: any): Promise<any> {
    return publicIPAddressService.getPublicIPAddresses(workspaceId, regionId);
  }

  getPrivateNetworks(workspaceId: any, regionId: any): Promise<any> {
    return privateNetworkService.getPrivateNetworks(workspaceId, regionId);
  }

  refreshWorkspaces() {
    return new Promise(resolve => {
      this.getWorkspaces()
        .then((data: any) => {
          this.workspaces = data.workspaces;
          resolve();
        })
        .catch(() => {
          resolve();
        });
    });
  }

  isPublicIpAddressActive(workspaceId: any, regionId: any, publicIpAddressId: any) {
    return new Promise(resolve => {
      const publicIpAddress = this.publicIpAddresses.find((item: any) => item.id === parseInt(publicIpAddressId, 10));
      if (publicIpAddress) {
        resolve(true);
      } else {
        this.getPublicIpAddresses(workspaceId, regionId)
          .then((data: any) => {
            this.publicIpAddresses = data.public_ip_addresses;
            const publicIpAddress = this.publicIpAddresses.find(
              (item: any) => item.id === parseInt(publicIpAddressId, 10)
            );
            if (publicIpAddress) {
              resolve(true);
            } else {
              resolve(false);
            }
          })
          .catch(() => {
            resolve(false);
          });
      }
    });
  }

  isPrivateNetworkActive(workspaceId: any, regionId: any, privateNetworkId: any) {
    return new Promise(resolve => {
      const privateNetwork = this.privateNetworks.find((item: any) => item.id === parseInt(privateNetworkId, 10));
      if (privateNetwork) {
        resolve(true);
      } else {
        this.getPrivateNetworks(workspaceId, regionId)
          .then((data: any) => {
            this.privateNetworks = data.private_networks;
            const privateNetwork = this.privateNetworks.find((item: any) => item.id === parseInt(privateNetworkId, 10));
            if (privateNetwork) {
              resolve(true);
            } else {
              resolve(false);
            }
          })
          .catch(() => {
            resolve(false);
          });
      }
    });
  }

  isWorkspaceActive(workspaceId: any) {
    return new Promise(resolve => {
      const workspace = this.workspaces.find((item: any) => item.id === parseInt(workspaceId, 10));
      if (workspace) {
        resolve(!!workspace.activated);
      } else {
        this.getWorkspaces()
          .then((data: any) => {
            this.workspaces = data.workspaces;
            const workspace = this.workspaces.find((item: any) => item.id === parseInt(workspaceId, 10));
            if (workspace) {
              resolve(!!workspace.activated);
            } else {
              resolve(false);
            }
          })
          .catch(() => {
            resolve(false);
          });
      }
    });
  }
}

export const workspaceAccessService = new WorkspaceAccessService();
